import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import RadioInput from '@repo/ui/radio-input'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import {
  LanguageEnum,
  languageEnumMapping
} from '../../../lib/types/enums/languages/language.enum'
import {
  LanguageLevelEnum,
  languageLevelEnumMapping
} from '../../../lib/types/enums/languages/language-level.enum'
import { LanguageLevelInput } from '../../../lib/types/models/languages/language-level-input'
import { StaffApplicationInput } from '../../../lib/types/models/staff-application/staff-application-input'

const StaffApplicationFormLanguage = () => {
  const { watch, setValue } = useFormContext<StaffApplicationInput>()
  const languageMapping = languageEnumMapping()

  const languageLevels = watch('languagesTaught')

  const handleChange = (language: LanguageEnum, level: LanguageLevelEnum) => {
    const allLanguages = Object.values(LanguageEnum)
    const updatedLanguageLevels = allLanguages
      .filter(
        (lang) => languageLevels?.find((item) => item.language === lang) || lang === language
      )
      .map((lang) => {
        if (lang === language) return { language, level }
        return languageLevels?.find((item) => item.language === lang)
      })

    setValue('languagesTaught', updatedLanguageLevels as LanguageLevelInput[])
  }

  return (
    <InnerBox title="Langues pratiquées">
      {Object.values(LanguageEnum).map((language) => {
        const Icon = languageMapping[language].icon
        return (
          <div key={language} className="mb-3">
            <div className="flex items-center gap-1">
              <Typography
                variant={'label-semibold'}
                className={'flex gap-1 items-center'}
                color={tailwindColors.grey.lighter}
              >
                {languageMapping[language].label}
                <Icon className={'min-w-4 min-h-4 w-4 h-4 rounded-full'} />
              </Typography>
            </div>
            <div className="flex items-center justify-between mt-1">
              {Object.values(LanguageLevelEnum).map((level) => (
                <RadioInput
                  key={level}
                  label={languageLevelEnumMapping[level].label}
                  name={`languagesTaught.${language}`}
                  checked={
                    languageLevels?.find((item) => item.language === language)?.level === level
                  }
                  onCheck={() => handleChange(language, level)}
                />
              ))}
            </div>
          </div>
        )
      })}
    </InnerBox>
  )
}

export default StaffApplicationFormLanguage
